<datex-grid #$gridComponent *ngIf="initialized " [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="delete_button" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    (click)="on_delete_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch">
    </div>
  </ng-container>


  <ng-container gridColumnDef="lookup">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.lookup.displayControl.styles.style"
          [ngClass]="row.cells.lookup.displayControl.styles.classes"
          [matTooltip]="row.cells.lookup.displayControl.tooltip">{{row.cells.lookup.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['lookup_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.lookup.editControl.readOnly || row.cells.lookup.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.lookup.editControl.placeholder}}"
            [ngStyle]="row.cells.lookup.editControl.styles.style"
            [ngClass]="row.cells.lookup.editControl.styles.classes"
            [matTooltip]="row.cells.lookup.editControl.tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="status_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.status_name.displayControl.styles.style"
          [ngClass]="row.cells.status_name.displayControl.styles.classes"
          [matTooltip]="row.cells.status_name.displayControl.tooltip">{{row.cells.status_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Totes-tote_container_statuses_dd_single 
        data-cy="selector"
        [type]="row.cells.status_name.editControl.type"
        [formControl]="row.formGroup.controls['status_name_edit']"
        (displayTextChange)="row.cells.status_name.editControl.displayText=$event"
        [placeholder]="row.cells.status_name.editControl.placeholder"
        [styles]="row.cells.status_name.editControl.styles"
        [tooltip]="row.cells.status_name.editControl.tooltip"
    >
    </Totes-tote_container_statuses_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="type_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.type_name.displayControl.styles.style"
          [ngClass]="row.cells.type_name.displayControl.styles.classes"
          [matTooltip]="row.cells.type_name.displayControl.tooltip">{{row.cells.type_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Totes-tote_container_types_dd_single 
        data-cy="selector"
        [type]="row.cells.type_name.editControl.type"
        [formControl]="row.formGroup.controls['type_name_edit']"
        (displayTextChange)="row.cells.type_name.editControl.displayText=$event"
        [placeholder]="row.cells.type_name.editControl.placeholder"
        [styles]="row.cells.type_name.editControl.styles"
        [tooltip]="row.cells.type_name.editControl.tooltip"
    >
    </Totes-tote_container_types_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="type_description">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.type_description.displayControl.styles.style"
          [ngClass]="row.cells.type_description.displayControl.styles.classes"
          [matTooltip]="row.cells.type_description.displayControl.tooltip">{{row.cells.type_description.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['type_description_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.type_description.editControl.readOnly || row.cells.type_description.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.type_description.editControl.placeholder}}"
            [ngStyle]="row.cells.type_description.editControl.styles.style"
            [ngClass]="row.cells.type_description.editControl.styles.classes"
            [matTooltip]="row.cells.type_description.editControl.tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="warehouse_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.warehouse_name.displayControl.styles.style"
          [ngClass]="row.cells.warehouse_name.displayControl.styles.classes"
          [matTooltip]="row.cells.warehouse_name.displayControl.tooltip">{{row.cells.warehouse_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Totes-warehouses_dd_single 
        data-cy="selector"
        [type]="row.cells.warehouse_name.editControl.type"
        [formControl]="row.formGroup.controls['warehouse_name_edit']"
        (displayTextChange)="row.cells.warehouse_name.editControl.displayText=$event"
        [placeholder]="row.cells.warehouse_name.editControl.placeholder"
        [styles]="row.cells.warehouse_name.editControl.styles"
        [tooltip]="row.cells.warehouse_name.editControl.tooltip"
    >
    </Totes-warehouses_dd_single>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
